export default [
    {
        path: '/lp/invite-my-landlord',
        component: require('../components/the-layout-www').default,
        children: [
            {
                path: '',
                component: require('../views/landing-pages/invite-my-landlord/index').default,
                meta: {
                    'the-layout-www': {
                        bg: 'hero-background-white'
                    }
                }
            }
        ]
    },
    {
        path: '/lp/market-your-properties-for-free',
        component: require('../views/landing-pages/market-your-properties-for-free/index').default
    },
    {
        path: '/lp/market-your-properties-for-free-1',
        component: require('../components/the-layout-www').default,
        children: [
            {
                path: '',
                component: require('../views/landing-pages/market-your-properties-for-free/index-1').default,
                meta: {
                    'the-layout-www': {
                        bg: 'hero-background-white'
                    }
                }
            }
        ]
    },
    {
        path: '/lp/market-your-properties-for-free-2',
        component: require('../views/landing-pages/market-your-properties-for-free/index-2').default
    },
    {
        path: '/lp/market-your-properties-for-free-3',
        component: require('../views/landing-pages/market-your-properties-for-free/index-3').default
    },
    {
        path: '/lp/market-your-properties-for-free-4',
        component: require('../views/landing-pages/market-your-properties-for-free/index-4').default
    },
    {
        path: '/lp/market-your-properties-for-free-5',
        component: require('../views/landing-pages/market-your-properties-for-free/index-5').default
    },
    {
        path: '/lp/late-rents',
        component: require('../views/landing-pages/late-rents/index').default
    },
    {
        path: '/lp/hmo-rent-collection',
        component: require('../views/landing-pages/hmo-rent-collection/index').default
    },
    {
        path: '/lp/hmo-rent-collection-1',
        component: require('../views/landing-pages/hmo-rent-collection/index-1').default
    },
    {
        path: '/lp/online-rent-collection',
        component: require('../views/landing-pages/online-rent-collection/index').default
    },
    {
        path: '/lp/online-rent-collection-1',
        component: require('../views/landing-pages/online-rent-collection/index-1').default
    },
    {
        path: '/lp/online-letting-agent',
        component: require('../views/landing-pages/online-letting-agent/index').default
    },
    {
        path: '/lp/online-letting-agent-1',
        component: require('../views/landing-pages/online-letting-agent/index-1').default
    },
    /*
    {
        path: '/lp/online-property-management',
        component: require('../views/landing-pages/online-property-management/index').default
    },
    {
        path: '/lp/online-property-management-1',
        component: require('../views/landing-pages/online-property-management/index-1').default
    },
    {
        path: '/lp/online-property-management-2',
        component: require('../views/landing-pages/online-property-management/index-2').default
    },
    {
        path: '/lp/online-property-management-3',
        component: require('../views/landing-pages/online-property-management/index-3').default
    },
    */
    {
        path: '/lp/pay-rent-with-credit-card',
        component: require('../views/landing-pages/pay-rent-with-credit-card/index').default
    },
    {
        path: '/lp/pay-rent-with-credit-card-1',
        component: require('../views/landing-pages/pay-rent-with-credit-card/index-1').default
    },
    {
        path: '/lp/pay-rent-with-credit-card-1',
        component: require('../views/landing-pages/pay-rent-with-credit-card/index-1').default
    },
    {
        path: '/lp/property-management',
        component: require('../views/landing-pages/property-management/index').default
    },
    {
        path: '/lp/inventories',
        component: require('../views/landing-pages/inventories/index').default
    }
]
